import React, {Component} from "react";
import ImageMapPos from "./ImageMapPos";
import {Chip, Divider, Grid, MenuItem, Select, Tooltip, Typography} from "@mui/material";
import T0Streak from "./T0Streak";
import FocusTest from "./FocusTest";
import FocusPointsLayer from "./FocusPointsLayer";
import ImageGrid from "./ImageGrid";
import TXTY from "./TXTY";
import TXTYText from "./TXTYText";
import TXTYPattern from "./TXTYPattern"
import Islands from "./Islands";
import RescanIslands from "./RescanIslands";
import TiltFocusPoints from "./TiltFocusPoints";
import FFTRatioFourD from "./FFTRatioFourD";
import FFTRatioFourDH from "./FFTRatioFourDH";
import FFTRatioFourDText from "./FFTRatioFourDText";
import FFTFourDText from "./FFTFourDText";
import CornerBlur from "./CornerBlur";
import CornerBlurText from "./CornerBlurText";
import StitchRound0Graphv2 from "./StitchRound0Graphv2";
import StitchPreRound0Disagreementv2 from "./StitchPreRound0Disagreementv2";
import StitchPostRound0Disagreementv2 from "./StitchPostRound0Disagreementv2";
import StitchRound0TileMotionv2 from "./StitchRound0TileMotionv2";
import StitchRound1Graphv2 from "./StitchRound1Graphv2";
import StitchPreRound1Disagreementv2 from "./StitchPreRound1Disagreementv2";
import StitchPostRound1Disagreementv2 from "./StitchPostRound1Disagreementv2";
import StitchRound1TileMotionv2 from "./StitchRound1TileMotionv2";
import StitchRound2Graphv2 from "./StitchRound2Graphv2";
import StitchPreRound2Disagreementv2 from "./StitchPreRound2Disagreementv2";
import StitchPostRound2Disagreementv2 from "./StitchPostRound2Disagreementv2";
import StitchRound2TileMotionv2 from "./StitchRound2TileMotionv2";
import StitchRound3Graphv2 from "./StitchRound3Graphv2";
import StitchPreRound3Disagreementv2 from "./StitchPreRound3Disagreementv2";
import StitchPostRound3Disagreementv2 from "./StitchPostRound3Disagreementv2";
import StitchRound3TileMotionv2 from "./StitchRound3TileMotionv2";
import StitchDisagreementv2 from "./StitchDisagreementv2";
import StitchGraphTextv2 from "./StitchGraphTextv2";
import StitchDisagreementTextv2 from "./StitchDisagreementTextv2";
import StitchingError from './StitchingError';
import SeamDistortion from './SeamDistortion';
import SeamDistortionText from './SeamDistortionText';
import SeamDistortionVector from './SeamDistortionVector';
import SeamDiagnosticSummary from './SeamDiagnosticSummary';
import {Loading} from "../components/components";
import {connect} from "react-redux";
import {get} from "../../../helper/request";
import {getPrefixedUrl, isEmptyArray, isEmptyObject, isTrue, notNull} from "../../../utils/utils";
import {error_manager} from "../../../helper/error_manager";
import {updateMapState} from "../../../redux_actions/maps.state.action";
import DropDistance from "./DropDistance";
import RescanFocusPoints from "./RescanFocusPoints";
import T1Streak from "./T1Streak";
import {updateRescanThreshValue1, updateRescanThreshValue2,} from "../../../redux_actions/gamma.state.action";
import {TileViewerConstants} from "../../../utils/const";
import Dicy from "./Dicy";
import Wsi3ZDropThresh from "./wsi3ZDropThresh";
import Take2Islands from "./Take2Islands";
import T2Streak from "./T2Streak";
import FFTFourDT1Text from "./FFTFourDT1Text";
import FFTRatioFourDT1 from "./FFTRatioFourDT1";
import FFTRatioFourDHT1 from "./FFTRatioFourDHT1";
import ZDropUnits from "./ZDropUnits";
import RescannedTiles from "./RescannedTiles";
import RescanCheckPoint from "./RescanCheckPoint";
import TiltFocusWithDicy from "./TiltFocusWithDicy";
import FocusPair from "./FocusPair";
import TiltFocusPair from "./TiltFocusPair";
import TileBackgroundLayers from "./TileBackgroundLayers";
import TXTYPatternText from "./TXTYPatternText";
import FocusDebugLayer from "./FocusDebugLayer";
import FdaDetails from "./FdaDetails";

class TileLayers extends Component {

    constructor(props) {
        super(props);

        this.isPathUnitMap = false;
        this.isFocusTestMap = false;
        this.isDeviceSettings = false;
        this.isRatioBlurCorner = false;
        this.isSporadicCells = false;
        this.isRescanThresh = false;
        this.isRescanThresh2 = false;
        this.isCountyTiltInfo = false;
        this.isScanFocusDebug = false;
        this.isTiltFocusPoints = false;
        this.isTiltFocusPairs = false;
        this.isFocusProfile = false;
        this.isDicy = false;
        this.isFocusDicy = false;
        this.isFocusPairs = false;
        this.isFocusImgPath = false;
        this.isFocusDirPath = false;
        this.isNormBlurValsFourd = false;
        this.isNormBlurValsFourdTake1 = false;
        this.isIslands = false;
        this.isRescanIslands = false;
        this.take2Islands = false;
        this.isStreaks = false;
        this.isScanMeta = false;
        this.isDropDistance = false;
        this.isDropDistImages = false;
        this.isFocusPlot = false;
        this.isMultipleFocusData = false;
        this.isFailedFocus = false;
        this.isFocusOffset = false;
        this.isTileFlag = false;
        this.isDropDistPlot = false;
        this.isStitchDisagreement = false;
        this.isStitchingError = false;
        this.isSeamDistortion = false;
        this.isSeamDiagnosticSummary = false;
        this.isStitchDoubtMap = false;
        this.isStitchPostR0Disagreement = false;
        this.isStitchPostR1Disagreement = false;
        this.isStitchPostR2Disagreement = false;
        this.isStitchPostR3Disagreement = false;
        this.isStitchPreR0Disagreement = false;
        this.isStitchPreR1Disagreement = false;
        this.isStitchPreR2Disagreement = false;
        this.isStitchPreR3Disagreement = false;
        this.isStitchPathR0 = false;
        this.isStitchPathR1 = false;
        this.isStitchPathR2 = false;
        this.isStitchPathR3 = false;
        this.isStitchR0TileMotion = false;
        this.isStitchR1TileMotion = false;
        this.isStitchR2TileMotion = false;
        this.isStitchR3TileMotion = false;
        this.isStitchStartPosR0 = false;
        this.isStitchStartPosR1 = false;
        this.isStitchStartPosR2 = false;
        this.isStitchStartPosR3 = false;

        // wsi 3 drop data
        this.isWSI3ZDropOutput = false;

        // z drop units for detecting z drop in scanner
        this.isZDropUnits = false;

        this.isRescanWorkflow = false;

        //TXTY Pattern Variables
        this.maxNorthX = -1; this.maxNorthY = -1; this.minNorthX = 10000; this.minNorthY = 10000;
        this.maxWestX = -1; this.maxWestY = -1; this.minWestX = 10000; this.minWestY = 10000;
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        !this.props.deviceSettings && this.fetchDeviceSettings();
        !this.props.pathUnitMap && this.fetchPathUnitMap();
        !this.props.focusTestMap && this.fetchFocusTestMap();
        !this.props.ratioBlurCorner && this.fetchRatioBlurCorner();
        !this.props.sporadicCells && this.fetchSporadicCells();
        !this.props.rescanThresh && this.fetchRescanThresh();
        !this.props.rescanThresh2 && this.fetchRescanThresh2();
        !this.props.countyTiltInfo && this.fetchCountyTiltInfo();
        !this.props.scanFocusDebug && this.fetchScanFocusDebug();
        !this.props.tiltFocusPoints && this.fetchTiltFocusPoints();
        !this.props.tiltFocusPairs && this.fetchTiltFocusPairs();
        !this.props.focusProfile && this.fetchFocusProfile();
        !this.props.dicy && this.fetchDicy();
        !this.props.focusDicy && this.fetchFocusDicy();
        !this.props.focusPairs && this.fetchFocusPairs();
        !this.props.focusImgPath && this.fetchFocusImgPath();
        !this.props.focusDirPath && this.fetchFocusDirPath();
        !this.props.normBlurValsFourd && this.fetchNormBlurValsFourd();
        !this.props.normBlurValsFourdTake1 && this.fetchNormBlurValsFourdTake1();
        !this.props.islands && this.fetchIslands();
        !this.props.rescanIslands && this.fetchRescanIslands();
        !this.props.take2Islands && this.fetchTake2Islands();
        !this.props.streaks && this.fetchStreaks();
        !this.props.scanMeta && this.fetchScanMeta();
        !this.props.dropDistance && this.fetchDropDistance();
        !this.props.dropDistImages && this.fetchDropDistImages();
        !this.props.stitchDisagreement && this.fetchStitchDisagreement();
        !this.props.stitchingError && this.fetchStitchingError();
        !this.props.seamDistortion && this.fetchSeamDistortion();
        !this.props.seamDiagnosticSummary && this.fetchSeamDiagnosticSummary();
        !this.props.stitchDoubtMap && this.fetchStitchDoubtMap();
        !this.props.stitchPostR0Disagreement && this.fetchStitchPostR0Disagreement();
        !this.props.stitchPostR1Disagreement && this.fetchStitchPostR1Disagreement();
        !this.props.stitchPostR2Disagreement && this.fetchStitchPostR2Disagreement();
        !this.props.stitchPostR3Disagreement && this.fetchStitchPostR3Disagreement();
        !this.props.stitchPreR0Disagreement && this.fetchStitchPreR0Disagreement();
        !this.props.stitchPreR1Disagreement && this.fetchStitchPreR1Disagreement();
        !this.props.stitchPreR2Disagreement && this.fetchStitchPreR2Disagreement();
        !this.props.stitchPreR3Disagreement && this.fetchStitchPreR3Disagreement();
        !this.props.stitchPathR0 && this.fetchStitchPathR0();
        !this.props.stitchPathR1 && this.fetchStitchPathR1();
        !this.props.stitchPathR2 && this.fetchStitchPathR2();
        !this.props.stitchPathR3 && this.fetchStitchPathR3();
        !this.props.stitchStartPosR0 && this.fetchStitchStartPosR0();
        !this.props.stitchStartPosR1 && this.fetchStitchStartPosR1();
        !this.props.stitchStartPosR2 && this.fetchStitchStartPosR2();
        !this.props.stitchStartPosR3 && this.fetchStitchStartPosR3();
        !this.props.stitchR0TileMotion && this.fetchStitchR0TileMotion();
        !this.props.stitchR1TileMotion && this.fetchStitchR1TileMotion();
        !this.props.stitchR2TileMotion && this.fetchStitchR2TileMotion();
        !this.props.stitchR3TileMotion && this.fetchStitchR3TileMotion();
        !this.props.focusPlots && this.fetchFocusPlots();
        !this.props.fineLocator && this.fetchFineLocator();
        !this.props.dropDistPlots && this.fetchDropDistPlots();
        !this.props.wsi3ZDropOutput && this.fetchWSI3ZDropOutput();
        !this.props.multipleFocusData && this.fetchMultipleFocusData();
        !this.props.failedFocus && this.fetchFailedFocusPoints();
        !this.props.focusOffset && this.fetchFocusOffset();
        !this.props.WSI3TestFocusUnits && this.fetchWSI3TestFocusUnits();
        !this.props.multipleWSI3Focus && this.fetchMultipleWSI3Focus();
        !this.props.tileFlag && this.fetchTileFlag();
        !this.props.zDropUnits && this.fetchZDropUnits();
        !this.props.rescanWorkflow && this.fetchRescanWorkflow();
    }

    fetchRescanWorkflow = () => {
        if (this.isRescanWorkflow)
            return;
        this.isRescanWorkflow = true;
        get(getPrefixedUrl('/debug/path/rescan_islands_0/rescan_workflow.json', this.props.slide, true))
            .then(rescanWorkflow => !this.getEmptyTileProp(rescanWorkflow) && this.updateMapState({rescanWorkflow}))
            .catch(error => error_manager("Failed to load rescan workflow data", error));
    }

    fetchTileFlagMeta = () => {
        get(`/api/tile-viewer/get_tile_inverse_flag/?id=${this.props.slide.id}`)
            .then(tileFlag => !this.getEmptyTileProp(tileFlag) && this.updateMapState({tileFlag}))
            .catch(error => error_manager("Failed to load data", error));
    }
    fetchTileFlag = () => {
        if (this.isTileFlag)
            return;
        this.isTileFlag = true;
        get(getPrefixedUrl('/debug/tile_flag.json', this.props.slide, true))
            .then(tileFlag => !this.getEmptyTileProp(tileFlag) && this.updateMapState({tileFlag}))
            .catch(() => this.fetchTileFlagMeta());
    }
    fetchMultipleWSI3Focus = () => {
        get(`/api/tile-viewer/get_multiple_wsi3_focus/?id=${this.props.slide.id}`)
            .then(multipleWSI3Focus => !this.getEmptyTileProp(multipleWSI3Focus) ? this.updateMapState({multipleWSI3Focus}) : this.fetchMultipleFocusDataMeta())
            .catch(error => this.fetchMultipleFocusDataMeta());
    }
    fetchMultipleFocusDataMeta = () => {
        get(`/api/tile-viewer/get_multiple_focus_points/?id=${this.props.slide.id}`)
            .then(multipleFocusData => !this.getEmptyTileProp(multipleFocusData) && this.updateMapState({multipleFocusData}))
            .catch(error => error_manager("Failed to load multiple focus data", error));
    }
    fetchMultipleFocusData = () => {
        if (this.isMultipleFocusData)
            return;
        this.isMultipleFocusData = true;
        get(getPrefixedUrl('/debug/multiple_focus.json', this.props.slide, true))
            .then(multipleFocusData => !this.getEmptyTileProp(multipleFocusData) ? this.updateMapState({multipleFocusData}) : this.fetchMultipleFocusDataMeta())
            .catch(() => this.fetchMultipleFocusDataMeta());
    }
    fetchWSI3TestFocusUnits = () => {
        if (this.isWSI3TestFocusUnits)
            return;
        this.isWSI3TestFocusUnits = true;
        get(getPrefixedUrl('/meta/wsi3_test_focus_units.json', this.props.slide, true))
            .then(WSI3TestFocusUnits => !this.getEmptyTileProp(WSI3TestFocusUnits) && this.updateMapState({WSI3TestFocusUnits}))
            .catch(error => error_manager("Failed to load WSI3 Test FocusUnits", error));
    }
    fetchFailedFocusPointsMeta = () => {
        get(`/api/tile-viewer/get_failed_focus_points/?id=${this.props.slide.id}`)
            .then(failedFocus => !this.getEmptyTileProp(failedFocus) && this.updateMapState({failedFocus}))
            .catch(error => error_manager("Failed to load focus failed data", error))
    }
    fetchFailedFocusPoints = () => {
        if (this.isFailedFocus)
            return;
        this.isFailedFocus = true;
        get(getPrefixedUrl('/debug/failed_focus_points.json', this.props.slide, true))
            .then(failedFocus => !this.getEmptyTileProp(failedFocus) ? this.updateMapState({failedFocus}) : this.fetchFailedFocusPointsMeta())
            .catch(() => this.fetchFailedFocusPointsMeta())
    }
    fetchFocusOffsetMeta = () => {
        get(`/api/tile-viewer/get_focus_offset/?id=${this.props.slide.id}`)
            .then(focusOffset => !this.getEmptyTileProp(focusOffset) && this.updateMapState({focusOffset}))
            .catch((error => error_manager("Failed to load offset data", error)))
    }
    fetchFocusOffset = () => {
        if (this.isFocusOffset)
            return;
        this.isFocusOffset = true;
        get(getPrefixedUrl('/debug/focus_offset_val.json', this.props.slide, true))
            .then(focusOffset => !this.getEmptyTileProp(focusOffset) && this.updateMapState({focusOffset}))
            .catch(() => this.fetchFocusOffsetMeta())
    }
    fetchFocusPlotsMeta = () => {
        get(`/api/tile-viewer/get_focus_plot_path/?id=${this.props.slide.id}`)
            .then(focusPlots => !this.getEmptyTileProp(focusPlots) && this.updateMapState({focusPlots}))
            .catch(error => error_manager("Failed to load focus plots data", error));
    }
    fetchFocusPlots = () => {
        if (this.isFocusPlot)
            return;
        this.isFocusPlot = true;
        get(getPrefixedUrl('/debug/focus_plot.json', this.props.slide, true))
            .then(focusPlots => !this.getEmptyTileProp(focusPlots) ? this.updateMapState({focusPlots}) : this.fetchFocusPlotsMeta())
            .catch(() => this.fetchFocusPlotsMeta());
    }
    fetchDropDistPlotsMeta = () => {
        get(`/api/tile-viewer/get_drop_dist_plot/?id=${this.props.slide.id}`)
            .then(dropDistPlots => !this.getEmptyTileProp(dropDistPlots) && this.updateMapState({dropDistPlots}))
            .catch(error => error_manager("Failed to load drop dist plot data", error));
    }
    fetchDropDistPlots = () => {
        if (this.isDropDistPlot)
            return;
        this.isDropDistPlot = true;
        get(getPrefixedUrl('/debug/drop_dist_plot.json', this.props.slide, true))
            .then(dropDistPlots => !this.getEmptyTileProp(dropDistPlots) && this.updateMapState({dropDistPlots}))
            .catch(() => this.fetchDropDistPlotsMeta());
    }
    fetchPathUnitMap = () => {
        if (this.isPathUnitMap)
            return;
        this.isPathUnitMap = true;
        get(getPrefixedUrl('/inter-process/pathunitmap.json', this.props.slide, true))
            .then(pathUnitMap => !this.getEmptyTileProp(pathUnitMap) && this.updateMapState({pathUnitMap}))
            .catch(error => error_manager("Failed to load pathUnitMap data", error));
    }
    fetchFocusTestMap = () => {
        if (this.isFocusTestMap)
            return;
        this.isFocusTestMap = true;
        get(getPrefixedUrl('/fda_metrics/focusing_test/results.json', this.props.slide, true))
            .then(focusTestMap => !this.getEmptyTileProp(focusTestMap) && this.updateMapState({focusTestMap}))
            .catch(error => error_manager("Failed to load FocusTestMap data", error));
    }
    fetchDeviceSettings = () => {
        if (this.isDeviceSettings)
            return;
        this.isDeviceSettings = true;
        get(getPrefixedUrl('/meta/device_settings.json', this.props.slide, true))
            .then(deviceSettings => !this.getEmptyTileProp(deviceSettings) && this.updateMapState({deviceSettings}))
            .catch(error => error_manager("Failed to load deviceSettings data", error));
    }

    fetchSporadicCells = () => {
        if (this.isSporadicCells)
            return;
        this.isSporadicCells = true;
        get(getPrefixedUrl('/meta/sporadic_cells.json', this.props.slide, true))
            .then(sporadicCells => !this.getEmptyTileProp(sporadicCells) && this.updateMapState({sporadicCells}))
            .catch(error => error_manager("Failed to load sporadic cells data", error));
    }
    fetchRatioBlurCorner = () => {
        if (this.isRatioBlurCorner)
            return;
        this.isRatioBlurCorner = true;
        get(getPrefixedUrl('/meta/blur_vals_on_corner.json', this.props.slide, true))
            .then(ratioBlurCorner => !this.getEmptyTileProp(ratioBlurCorner) && this.updateMapState({ratioBlurCorner}))
            .catch(error => error_manager("Failed to load ratioBlurCorner data", error));
    }
    fetchRescanThresh = () => {
        if (this.isRescanThresh)
            return;
        this.isRescanThresh = true;
        get(getPrefixedUrl('/meta/rescan_blur_ratio_threshold.json', this.props.slide, true))
            .then(rescanThresh => !this.getEmptyTileProp(rescanThresh) && this.updateMapState({rescanThresh}))
            .catch(error => error_manager("Failed to load rescanThresh data", error));
    }
    fetchRescanThresh2 = () => {
        if (this.isRescanThresh2)
            return;
        this.isRescanThresh2 = true;
        get(getPrefixedUrl('/meta/rescan_blur_ratio_threshold_l2.json', this.props.slide, true))
            .then(rescanThresh2 => !this.getEmptyTileProp(rescanThresh2) && this.updateMapState({rescanThresh2}))
            .catch(error => error_manager("Failed to load rescanThresh2 data", error));
    }
    fetchCountyTiltInfo = () => {
        if (this.isCountyTiltInfo)
            return;
        this.isCountyTiltInfo = true;
        get(getPrefixedUrl('/meta/county_order_and_tilt.json', this.props.slide, true))
            .then(countyTiltInfo => !this.getEmptyTileProp(countyTiltInfo) && this.updateMapState({countyTiltInfo}))
            .catch(error => error_manager("Failed to load countyTiltInfo data", error));
    }
    fetchScanFocusDebug = () => {
        if (this.isScanFocusDebug)
            return;
        this.isScanFocusDebug = true;
        get(getPrefixedUrl('/meta/scan_focus_debug.json', this.props.slide, true))
            .then(scanFocusDebug => !this.getEmptyTileProp(scanFocusDebug) && this.updateMapState({scanFocusDebug}))
            .catch(error => error_manager("Failed to load scanFocusDebug data", error));
    }
    fetchTiltFocusPoints = () => {
        if (this.isTiltFocusPoints)
            return;
        this.isTiltFocusPoints = true;
        get(getPrefixedUrl('/debug/tilt_focus_pts.json', this.props.slide, true))
            .then(tiltFocusPoints => this.updateMapState({tiltFocusPoints}))
            .catch(error => {
                let tiltFocusPoints = []
                this.updateMapState({tiltFocusPoints});
                error_manager("Failed to load tiltFocusPoints data", error)
            });
    }
    fetchFocusProfile = () => {
        if (this.isFocusProfile)
            return;
        this.isFocusProfile = true;
        get(getPrefixedUrl('/meta/focus_profile.json', this.props.slide, true))
            .then(focusProfile => !this.getEmptyTileProp(focusProfile) && this.updateMapState({focusProfile}))
            .catch(error => error_manager("Failed to load focusProfile data", error));
    }
    fetchDicyMeta = () => {
        get(`/api/tile-viewer/get_dicy_path_dir/?id=${this.props.slide.id}`)
            .then(dicy => !this.getEmptyTileProp(dicy) && this.updateMapState({dicy}))
            .catch(error => error_manager("Failed to load dicyMeta data", error));
    }
    fetchDicy = () => {
        if (this.isDicy)
            return;
        this.isDicy = true;
        get(getPrefixedUrl('/debug/dicy_path.json', this.props.slide, true))
            .then(dicy => !this.getEmptyTileProp(dicy) && this.updateMapState({dicy}))
            .catch(() => this.fetchDicyMeta());
    }
    fetchFocusPairs = () => {
        if (this.isFocusPairs)
            return;
        this.isFocusPairs = true;
        get(getPrefixedUrl('/meta/field_pair_debug_info.json', this.props.slide, true))
            .then(focusPairs => !this.getEmptyTileProp(focusPairs) && this.updateMapState({focusPairs}))
            .catch(error => error_manager("Failed to load focus pairs data", error));
    }
    fetchTiltFocusPairs = () => {
        if (this.isTiltFocusPairs)
            return;
        this.isTiltFocusPairs = true;
        get(getPrefixedUrl('/meta/tilt_field_pair_debug_info.json', this.props.slide, true))
            .then(tiltFocusPairs => !this.getEmptyTileProp(tiltFocusPairs) && this.updateMapState({tiltFocusPairs}))
            .catch(error => error_manager("Failed to load tilt focus pairs data", error));
    }
    fetchFocusDicyMeta = () => {
        get(`/api/tile-viewer/get_focus_dicy_path/?id=${this.props.slide.id}`)
            .then(focusDicy => this.updateMapState({focusDicy}))
            .catch(error => error_manager("Failed to load focusDicyMeta data", error));
    }
    fetchFocusDicy = () => {
        if (this.isFocusDicy)
            return;
        this.isFocusDicy = true;
        get(getPrefixedUrl('/debug/focus_dicy_path.json', this.props.slide, true))
            .then(focusDicy => !this.getEmptyTileProp(focusDicy) ? this.updateMapState({focusDicy}) : this.fetchFocusDicyMeta())
            .catch(() => this.fetchFocusDicyMeta());
    }
    fetchNormBlurValsFourd = () => {
        if (this.isNormBlurValsFourd)
            return;
        this.isNormBlurValsFourd = true;
        get(getPrefixedUrl('/meta/post_scan_pre_norm_blur_vals_java_fourd.json', this.props.slide, true))
            .then(normBlurValsFourd => !this.getEmptyTileProp(normBlurValsFourd) && this.updateMapState({normBlurValsFourd}))
            .catch(error => error_manager("Failed to load normBlurValsFourd data", error));
    }
    fetchNormBlurValsFourdTake1 = () => {
        if (this.isNormBlurValsFourdTake1)
            return;
        this.isNormBlurValsFourdTake1 = true;
        get(getPrefixedUrl('/meta/post_scan_pre_norm_blur_vals_java_fourd_take1.json', this.props.slide, true))
            .then(normBlurValsFourdTake1 => !this.getEmptyTileProp(normBlurValsFourdTake1) &&
                this.updateMapState({normBlurValsFourdTake1}))
            .catch(error => error_manager("Failed to load normBlurValsFourdTake1 data", error));
    }
    fetchFocusDirPathMeta = () => {
        if (this.isFocusDirPathMeta)
            return;
        this.isFocusDirPathMeta = true;
        get(`/api/tile-viewer/get_focus_profile_path_dir/?id=${this.props.slide.id}`)
            .then(focusDirPath => !this.getEmptyTileProp(focusDirPath) && this.updateMapState({focusDirPath}))
            .catch(error => error_manager("Failed to load focusPath data", error));
    }
    fetchFocusImgPathMeta = () => {
        get(`/api/tile-viewer/get_focus_profile_img/?id=${this.props.slide.id}`)
            .then(focusImgPath => this.updateMapState({focusImgPath}))
            .catch(error => error_manager("Failed to load focusImgPath data", error));
    }
    fetchFocusImgPath = () => {
        if (this.isFocusImgPath)
            return;
        this.isFocusImgPath = true;
        get(getPrefixedUrl('/debug/focus_img_paths.json', this.props.slide, true))
            .then(focusImgPath => !this.getEmptyTileProp(focusImgPath) ? this.updateMapState({focusImgPath}) : this.fetchFocusImgPathMeta())
            .catch(() => this.fetchFocusImgPathMeta());
    }
    fetchFocusDirPath = () => {
        if (this.isFocusDirPath)
            return;
        this.isFocusDirPath = true;
        get(getPrefixedUrl('/debug/focus_profile_path.json', this.props.slide, true))
            .then(focusDirPath => !this.getEmptyTileProp(focusDirPath) && this.updateMapState({focusDirPath}))
            .catch(() => this.fetchFocusDirPathMeta());
    }
    fetchIslands = () => {
        if (this.isIslands)
            return;
        this.isIslands = true;
        get(getPrefixedUrl('/meta/scan_islands.json', this.props.slide, true))
            .then(islands => !this.getEmptyTileProp(islands) && this.updateMapState({islands}))
            .catch(error => error_manager("Failed to load islands data", error));
    }
    fetchRescanIslands = () => {
        if (this.isRescanIslands)
            return;
        this.isRescanIslands = true;
        get(getPrefixedUrl('/debug/path/rescan_islands_0/rescan_pathunits.json', this.props.slide, true))
            .then(rescanIslands => !this.getEmptyTileProp(rescanIslands) && this.updateMapState({rescanIslands}))
            .catch(error => error_manager("Failed to load rescanIslands data", error));
    }
    fetchTake2Islands = () => {
        if (this.isTake2Islands)
            return;
        this.isTake2Islands = true;
        get(getPrefixedUrl('/debug/path/rescan_islands_1/rescan_pathunits.json', this.props.slide, true))
            .then(take2Islands => !this.getEmptyTileProp(take2Islands) && this.updateMapState({take2Islands}))
            .catch(error => error_manager("Failed to load take2Islands data", error));
    }
    fetchStreaks = () => {
        if (this.isStreaks)
            return;
        this.isStreaks = true;
        get(getPrefixedUrl('/meta/xyzstreaks.json', this.props.slide, true))
            .then(streaks => !this.getEmptyTileProp(streaks) && this.updateMapState({streaks}))
            .catch(error => error_manager("Failed to load streaks data", error));
    }
    fetchScanMeta = () => {
        if (this.isScanMeta)
            return;
        this.isScanMeta = true;
        get(getPrefixedUrl('/res/scan_meta_v2.json', this.props.slide, true))
            .then(scanMeta => {
                this.calculateTXTYPreData(scanMeta).then(this.updateMapState({scanMeta}));
            })
            .catch(error => error_manager("Failed to load scanMeta data", error));
    }
    fetchDropDistance = () => {
        if (this.isDropDistance)
            return;
        this.isDropDistance = true;
        get(getPrefixedUrl('/meta/drop_distance_point.json', this.props.slide, true))
            .then(dropDistance => !this.getEmptyTileProp(dropDistance) && this.updateMapState({dropDistance}))
            .catch(error => error_manager("Failed to load dropDistance data", error));
    }
    fetchDropDistImagesMeta = () => {
        get(`/api/tile-viewer/get_drop_distance_images/?id=${this.props.slide.id}`)
            .then(dropDistImages => !this.getEmptyTileProp(dropDistImages) && this.updateMapState({dropDistImages}))
            .catch(error => error_manager("Failed to load dropDistImages data", error));
    }
    fetchDropDistImages = () => {
        if (this.isDropDistImages)
            return;
        this.isDropDistImages = true;
        get(getPrefixedUrl('/debug/drop_dist_img_paths.json', this.props.slide, true))
            .then(dropDistImages => !this.getEmptyTileProp(dropDistImages) && this.updateMapState({dropDistImages}))
            .catch(() => this.fetchDropDistImagesMeta());
    }
    fetchFineLocatorMeta = () => {
        get(`/api/tile-viewer/get_fine_locator_focus/?id=${this.props.slide.id}`)
            .then(fineLocator => !this.getEmptyTileProp(fineLocator) && this.updateMapState({fineLocator}))
            .catch(error => error_manager("Failed to load fineLocator data", error));
    }
    fetchFineLocator = () => {
        if (this.isFineLocator)
            return;
        this.isFineLocator = true;
        get(getPrefixedUrl('/debug/fine_locator_focus.json', this.props.slide, true))
            .then(fineLocator => !this.getEmptyTileProp(fineLocator) && this.updateMapState({fineLocator}))
            .catch(() => this.fetchFineLocatorMeta());
    }
    fetchStitchDisagreement = () => {
        if (this.isStitchDisagreement)
            return;
        this.isStitchDisagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_final_v2.json', this.props.slide, true))
            .then(stitchDisagreement => !this.getEmptyTileProp(stitchDisagreement) && this.updateMapState({stitchDisagreement}))
            .catch(error => error_manager("Failed to load stitchDisagreement data", error));
    }
    fetchStitchingError = () => {
        if (this.isStitchingError)
            return;
        this.isStitchingError = true;
        get(getPrefixedUrl('/meta/stitching_error.json', this.props.slide, true))
            .then(stitchingError => !this.getEmptyTileProp(stitchingError) && this.updateMapState({stitchingError}))
            .catch(error => error_manager("Failed to load stitchingError data", error));
    }
    fetchSeamDistortion = () => {
        if (this.isSeamDistortion)
            return;
        this.isSeamDistortion = true;
        get(getPrefixedUrl('/debug/stitching/seam_diagnostic/seam_diagnostic_viewer.json', this.props.slide, true))
            .then(seamDistortion => !this.getEmptyTileProp(seamDistortion) && this.updateMapState({seamDistortion}))
            .catch(error => error_manager("Failed to load seamDistortion data", error));
    }
    fetchSeamDiagnosticSummary = () => {
        if (this.isSeamDiagnosticSummary)
            return;
        this.isSeamDiagnosticSummary = true;
        get(getPrefixedUrl('/debug/stitching/seam_diagnostic/diagnostic_summary.json', this.props.slide, true))
            .then(seamDiagnosticSummary => !this.getEmptyTileProp(seamDiagnosticSummary) && this.updateMapState({seamDiagnosticSummary}))
            .catch(error => error_manager("Failed to load seamDiagnosticSummary data", error));
    }
    fetchStitchDoubtMap = () => {
        if (this.isStitchDoubtMap)
            return;
        this.isStitchDoubtMap = true;
        get(getPrefixedUrl('/debug/stitching/stitch_doubt_map_v2.json', this.props.slide, true))
            .then(stitchDoubtMap => !this.getEmptyTileProp(stitchDoubtMap) && this.updateMapState({stitchDoubtMap}))
            .catch(error => error_manager("Failed to load stitchDoubtMap data", error));
    }

    //Stitching data R 0
    fetchStitchPostR0Disagreement = () => {
        if (this.isStitchPostR0Disagreement)
            return;
        this.isStitchPostR0Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_post_round0_v2.json', this.props.slide, true))
            .then(stitchPostR0Disagreement => !this.getEmptyTileProp(stitchPostR0Disagreement) &&
                this.updateMapState({stitchPostR0Disagreement}))
            .catch(error => error_manager("Failed to load stitchPostRound0Disagreement data", error));
    }
    fetchStitchPreR0Disagreement = () => {
        if (this.isStitchPreR0Disagreement)
            return;
        this.isStitchPreR0Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_pre_round0_v2.json', this.props.slide, true))
            .then(stitchPreR0Disagreement => !this.getEmptyTileProp(stitchPreR0Disagreement) &&
                this.updateMapState({stitchPreR0Disagreement}))
            .catch(error => error_manager("Failed to load stitchPreRound0Disagreement data", error));
    }
    fetchStitchPathR0 = () => {
        if (this.isStitchPathR0)
            return;
        this.isStitchPathR0 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_path_round0_v2.json', this.props.slide, true))
            .then(stitchPathR0 => !this.getEmptyTileProp(stitchPathR0) && this.updateMapState({stitchPathR0}))
            .catch(error => error_manager("Failed to load stitchPathRound0 data", error));
    }
    fetchStitchStartPosR0 = () => {
        if (this.isStitchStartPosR0)
            return;
        this.isStitchStartPosR0 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_start_positions_round0_v2.json', this.props.slide, true))
            .then(stitchStartPosR0 => !this.getEmptyTileProp(stitchStartPosR0) && this.updateMapState({stitchStartPosR0}))
            .catch(error => error_manager("Failed to load stitchStartPosRound0 data", error));
    }
    fetchStitchR0TileMotion = () => {
        if (this.isStitchR0TileMotion)
            return;
        this.isStitchR0TileMotion = true;
        get(getPrefixedUrl('/debug/stitching/stitch_tile_motion_post_round0_v2.json', this.props.slide, true))
            .then(stitchR0TileMotion => !this.getEmptyTileProp(stitchR0TileMotion) && this.updateMapState({stitchR0TileMotion}))
            .catch(error => error_manager("Failed to load stitchRound0TileMotion data", error));
    }

    //Stitching data Round 1
    fetchStitchPostR1Disagreement = () => {
        if (this.isStitchPostR1Disagreement)
            return;
        this.isStitchPostR1Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_post_round1_v2.json', this.props.slide, true))
            .then(stitchPostR1Disagreement => !this.getEmptyTileProp(stitchPostR1Disagreement) &&
                this.updateMapState({stitchPostR1Disagreement}))
            .catch(error => error_manager("Failed to load stitchPostRound1Disagreement data", error));
    }
    fetchStitchPreR1Disagreement = () => {
        if (this.isStitchPreR1Disagreement)
            return;
        this.isStitchPreR1Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_pre_round1_v2.json', this.props.slide, true))
            .then(stitchPreR1Disagreement => !this.getEmptyTileProp(stitchPreR1Disagreement) &&
                this.updateMapState({stitchPreR1Disagreement}))
            .catch(error => error_manager("Failed to load stitchPreRound1Disagreement data", error));
    }
    fetchStitchPathR1 = () => {
        if (this.isStitchPathR1)
            return;
        this.isStitchPathR1 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_path_round1_v2.json', this.props.slide, true))
            .then(stitchPathR1 => !this.getEmptyTileProp(stitchPathR1) && this.updateMapState({stitchPathR1}))
            .catch(error => error_manager("Failed to load stitchPathRound1 data", error));
    }
    fetchStitchStartPosR1 = () => {
        if (this.isStitchStartPosR1)
            return;
        this.isStitchStartPosR1 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_start_positions_round1_v2.json', this.props.slide, true))
            .then(stitchStartPosR1 => !this.getEmptyTileProp(stitchStartPosR1) && this.updateMapState({stitchStartPosR1}))
            .catch(error => error_manager("Failed to load stitchStartPosRound1 data", error));
    }
    fetchStitchR1TileMotion = () => {
        if (this.isStitchR1TileMotion)
            return;
        this.isStitchR1TileMotion = true;
        get(getPrefixedUrl('/debug/stitching/stitch_tile_motion_post_round1_v2.json', this.props.slide, true))
            .then(stitchR1TileMotion => !this.getEmptyTileProp(stitchR1TileMotion) && this.updateMapState({stitchR1TileMotion}))
            .catch(error => error_manager("Failed to load stitchRound1TileMotion data", error));
    }

    //Stitching data Round 2
    fetchStitchPostR2Disagreement = () => {
        if (this.isStitchPostR2Disagreement)
            return;
        this.isStitchPostR2Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_post_round2_v2.json', this.props.slide, true))
            .then(stitchPostR2Disagreement => !this.getEmptyTileProp(stitchPostR2Disagreement) &&
                this.updateMapState({stitchPostR2Disagreement}))
            .catch(error => error_manager("Failed to load stitchPostRound2Disagreement data", error));
    }
    fetchStitchPreR2Disagreement = () => {
        if (this.isStitchPreR2Disagreement)
            return;
        this.isStitchPreR2Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_pre_round2_v2.json', this.props.slide, true))
            .then(stitchPreR2Disagreement => !this.getEmptyTileProp(stitchPreR2Disagreement) &&
                this.updateMapState({stitchPreR2Disagreement}))
            .catch(error => error_manager("Failed to load stitchPreRound2Disagreement data", error));
    }
    fetchStitchPathR2 = () => {
        if (this.isStitchPathR2)
            return;
        this.isStitchPathR2 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_path_round2_v2.json', this.props.slide, true))
            .then(stitchPathR2 => !this.getEmptyTileProp(stitchPathR2) && this.updateMapState({stitchPathR2}))
            .catch(error => error_manager("Failed to load stitchPathRound2 data", error));
    }
    fetchStitchStartPosR2 = () => {
        if (this.isStitchStartPosR2)
            return;
        this.isStitchStartPosR2 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_start_positions_round2_v2.json', this.props.slide, true))
            .then(stitchStartPosR2 => !this.getEmptyTileProp(stitchStartPosR2) && this.updateMapState({stitchStartPosR2}))
            .catch(error => error_manager("Failed to load stitchStartPosRound2 data", error));
    }
    fetchStitchR2TileMotion = () => {
        if (this.isStitchR2TileMotion)
            return;
        this.isStitchR2TileMotion = true;
        get(getPrefixedUrl('/debug/stitching/stitch_tile_motion_post_round2_v2.json', this.props.slide, true))
            .then(stitchR2TileMotion => !this.getEmptyTileProp(stitchR2TileMotion) && this.updateMapState({stitchR2TileMotion}))
            .catch(error => error_manager("Failed to load stitchRound2TileMotion data", error));
    }

    //Stitching data Round 3
    fetchStitchPostR3Disagreement = () => {
        if (this.isStitchPostR3Disagreement)
            return;
        this.isStitchPostR3Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_post_round3_v2.json', this.props.slide, true))
            .then(stitchPostR3Disagreement => !this.getEmptyTileProp(stitchPostR3Disagreement) &&
                this.updateMapState({stitchPostR3Disagreement}))
            .catch(error => error_manager("Failed to load stitchPostRound3Disagreement data", error));
    }
    fetchStitchPreR3Disagreement = () => {
        if (this.isStitchPreR3Disagreement)
            return;
        this.isStitchPreR3Disagreement = true;
        get(getPrefixedUrl('/debug/stitching/stitch_disagreements_pre_round3_v2.json', this.props.slide, true))
            .then(stitchPreR3Disagreement => !this.getEmptyTileProp(stitchPreR3Disagreement) &&
                this.updateMapState({stitchPreR3Disagreement}))
            .catch(error => error_manager("Failed to load stitchPreRound3Disagreement data", error));
    }
    fetchStitchPathR3 = () => {
        if (this.isStitchPathR3)
            return;
        this.isStitchPathR3 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_path_round3_v2.json', this.props.slide, true))
            .then(stitchPathR3 => !this.getEmptyTileProp(stitchPathR3) && this.updateMapState({stitchPathR3}))
            .catch(error => error_manager("Failed to load stitchPathRound3 data", error));
    }
    fetchStitchStartPosR3 = () => {
        if (this.isStitchStartPosR3)
            return;
        this.isStitchStartPosR3 = true;
        get(getPrefixedUrl('/debug/stitching/stitch_start_positions_round3_v2.json', this.props.slide, true))
            .then(stitchStartPosR3 => !this.getEmptyTileProp(stitchStartPosR3) && this.updateMapState({stitchStartPosR3}))
            .catch(error => error_manager("Failed to load stitchStartPosRound3 data", error));
    }
    fetchStitchR3TileMotion = () => {
        if (this.isStitchR3TileMotion)
            return;
        this.isStitchR3TileMotion = true;
        get(getPrefixedUrl('/debug/stitching/stitch_tile_motion_post_round3_v2.json', this.props.slide, true))
            .then(stitchR3TileMotion => !this.getEmptyTileProp(stitchR3TileMotion) && this.updateMapState({stitchR3TileMotion}))
            .catch(error => error_manager("Failed to load stitchRound3TileMotion data", error));
    }

    fetchWSI3ZDropOutput = () => {
        if (this.isWSI3ZDropOutput)
            return;
        this.isWSI3ZDropOutput = true;
        get(getPrefixedUrl('/debug/wsi3_drop_output.json', this.props.slide, true))
            .then(wsi3ZDropOutput => !this.getEmptyTileProp(wsi3ZDropOutput) && this.updateMapState({wsi3ZDropOutput}))
            .catch(error => error_manager("Failed to load WSI3ZDropOutput data", error));
    }

    // z drop units to detect z drop
    fetchZDropUnits = () => {
        if (this.isZDropUnits)
            return;
        this.isZDropUnits = true;
        get(getPrefixedUrl('/meta/zdrop_units.json', this.props.slide, true))
            .then(zDropUnits => !this.getEmptyTileProp(zDropUnits) && this.updateMapState({zDropUnits}))
        .catch(error => error_manager("Failed to load zdrop units data", error));
    }


    updateMapState = (state) => this.props.dispatch(updateMapState(this.props.activeMapId, state));

    calculateTXTYPreData = (scanMeta) => new Promise((resolve, reject) => {
        for (let key in scanMeta) {
            if (key.endsWith("_5"))
                continue;
            
            if (notNull(scanMeta[key]["top"])){
                if (isTrue(scanMeta[key]["top"]["success"])) {
                    if (scanMeta[key]["top"]["ty"] > this.maxNorthY) {
                        this.maxNorthY = scanMeta[key]["top"]["ty"]
                    } else if (scanMeta[key]["top"]["ty"] < this.minNorthY) {
                        this.minNorthY = scanMeta[key]["top"]["ty"]
                    }
                    if (scanMeta[key]["top"]["tx"] > this.maxNorthX) {
                        this.maxNorthX = scanMeta[key]["top"]["tx"]
                    } else if (scanMeta[key]["top"]["tx"] < this.minNorthX) {
                        this.minNorthX = scanMeta[key]["top"]["tx"]
                    }
                }
            }
                
            if (notNull(scanMeta[key]["left"])) {
                if (isTrue(scanMeta[key]["left"]["success"])) {
                    if (scanMeta[key]["left"]["ty"] > this.maxWestY) {
                        this.maxWestY = scanMeta[key]["left"]["ty"]
                    } else if (scanMeta[key]["left"]["ty"] < this.minWestY) {
                        this.minWestY = scanMeta[key]["left"]["ty"]
                    }
                    if (scanMeta[key]["left"]["tx"] > this.maxWestX) {
                        this.maxWestX = scanMeta[key]["left"]["tx"]
                    } else if (scanMeta[key]["left"]["tx"] < this.minWestX) {
                        this.minWestX = scanMeta[key]["left"]["tx"]
                    }
                }
            } 
        }
        resolve();
    })

    changeRTvalue1 = e => this.props.dispatch(updateRescanThreshValue1(e.target.value));
    getRescanThreshValComponent1 = () =>
        <Tooltip placement={"bottom"}>
            <Select variant={"filled"} value={this.props.rescanThreshValue1}
                    onChange={(e) => this.changeRTvalue1(e)}>
                {Object.values(TileViewerConstants.THRESH_VALS).map(val =>
                    <MenuItem value={val}>
                        {val}
                    </MenuItem>)}
            </Select>
        </Tooltip>;

    changeRTvalue2 = e => this.props.dispatch(updateRescanThreshValue2(e.target.value));
    getRescanThreshValComponent2 = () =>
        <Tooltip placement={"bottom"}>
            <Select variant={"filled"} value={this.props.rescanThreshValue2}
                    onChange={(e) => this.changeRTvalue2(e)}>
                {Object.values(TileViewerConstants.THRESH_VALS).map(val =>
                    <MenuItem value={val}>
                        {val}
                    </MenuItem>)}
            </Select>
        </Tooltip>;

    getRescanWorkFlow = () => {
        let rescanCheckPoints = Object.keys(this.props.rescanWorkflow).length;
        const rescanWorkflow = [];
        for (let i = 0; i < rescanCheckPoints; i++) {
            rescanWorkflow.push(
            <Grid item margin={0.2}>
                <RescanCheckPoint id={`checkpoint${i}`} checkpoint={i}
                                  rescanColor={TileViewerConstants.TILE_COLORS[i % 10]} {...this.props}
                                  label={Object.entries(this.props.rescanWorkflow).sort()[i][0]}/>
            </Grid>
            )
        }
        return <Tooltip placement={"bottom"}>
            <Select variant={"filled"}>
                {rescanWorkflow}
            </Select>
        </Tooltip>;
    }
    getEmptyTileProp = (value) => !!((typeof value === 'object' && isEmptyObject(value)) || (Array.isArray(value) && isEmptyArray(value)));


    render() {
        if (!this.props.map)
            return <Loading/>;

        let {
            rescanWorkflow,
            tileFlag,
            multipleWSI3Focus,
            wsi3ZDropOutput,
            zDropUnits,
            failedFocus,
            multipleFocusData,
            dropDistPlots,
            focusPlots,
            pathUnitMap,
            focusTestMap,
            deviceSettings,
            ratioBlurCorner,
            sporadicCells,
            rescanThresh,
            rescanThresh2,
            countyTiltInfo,
            scanFocusDebug,
            tiltFocusPoints,
            focusProfile,
            focusOffset,
            dicy,
            focusDicy,
            focusImgPath,
            focusDirPath,
            normBlurValsFourd,
            normBlurValsFourdTake1,
            islands,
            rescanIslands,
            take2Islands,
            streaks,
            scanMeta,
            dropDistance,
            dropDistImages,
            stitchDisagreement,
            stitchingError,
            seamDistortion,
            seamDiagnosticSummary,
            stitchDoubtMap,
            stitchPostR0Disagreement,
            stitchPreR0Disagreement,
            stitchR0TileMotion,
            stitchPathR0,
            stitchStartPosR0,
            stitchPostR1Disagreement,
            stitchPreR1Disagreement,
            stitchR1TileMotion,
            stitchPathR1,
            stitchStartPosR1,
            stitchPostR2Disagreement,
            stitchPreR2Disagreement,
            stitchR2TileMotion,
            stitchPathR2,
            stitchStartPosR2,
            stitchPostR3Disagreement,
            stitchPreR3Disagreement,
            stitchR3TileMotion,
            stitchPathR3,
            stitchStartPosR3,
            tiltFocusPairs,
            focusPairs,
        } = this.props;

        return <Grid>
            <ImageMapPos {...this.props}/>
            <Divider/>
            {this.props.tileMapEnable && <Grid item margin={0.3}><TileBackgroundLayers {...this.props}/></Grid>}
            <Grid width={"100%"} container>
                <Grid item margin={0.2}>
                    {(pathUnitMap && deviceSettings && tileFlag) ? <ImageGrid {...this.props} /> :
                        <Chip label={'ImageGrid'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {(streaks && deviceSettings && tileFlag) ? <T0Streak {...this.props}/> :
                        <Chip label={'T0Streak'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {streaks && deviceSettings && tileFlag ? <T1Streak {...this.props}/> :
                        <Chip label={'T1Streak'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {streaks && deviceSettings && tileFlag ? <T2Streak {...this.props}/> :
                        <Chip label={'T2Streak'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {streaks && deviceSettings && tileFlag ? <RescannedTiles {...this.props}/> :
                        <Chip label={'RescannedTiles'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {dicy && deviceSettings && tileFlag ? <Dicy {...this.props}/> :
                        <Chip label={'Dicy'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {focusPairs && deviceSettings && tileFlag ? <FocusPair {...this.props}/> :
                        <Chip label={'Focus Pairs'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && focusOffset && multipleFocusData && focusDirPath
                    && focusImgPath && tiltFocusPoints && focusProfile && countyTiltInfo && deviceSettings
                    && focusPlots ? <FocusPointsLayer {...this.props}/> :
                        <Chip label={'Focus Points'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && scanFocusDebug && focusDirPath && focusImgPath 
                    && tiltFocusPoints && focusProfile && countyTiltInfo && deviceSettings
                    && focusPlots ? <FocusDebugLayer {...this.props} takeNumberForDebug={0}/> :
                        <Chip label={'Focus Debug'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && focusOffset && islands && deviceSettings && focusProfile && tiltFocusPoints && countyTiltInfo &&
                    focusDirPath && focusImgPath && focusDicy && focusPlots && multipleFocusData ?
                        <RescanFocusPoints {...this.props}/> :
                        <Chip label={'Rescan Focus Points'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && scanFocusDebug && focusDirPath && focusImgPath 
                    && tiltFocusPoints && focusProfile && countyTiltInfo && deviceSettings
                    && focusPlots ? <FocusDebugLayer {...this.props} takeNumberForDebug={1}/> :
                        <Chip label={'Rescan Focus Debug'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && focusOffset && tiltFocusPoints && focusProfile && countyTiltInfo && deviceSettings && focusDirPath &&
                    focusDicy && focusImgPath && focusPlots ? <TiltFocusPoints {...this.props}/> :
                        <Chip label={'Tilt Focus Points'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && focusOffset && tiltFocusPoints && focusProfile && countyTiltInfo && deviceSettings && focusDirPath &&
                    focusDicy && focusImgPath && focusPlots ? <TiltFocusWithDicy {...this.props}/> : null}
                </Grid>
                <Grid item margin={0.2}>
                    {tiltFocusPairs && deviceSettings && tileFlag ? <TiltFocusPair {...this.props}/> :
                        <Chip label={'Tilt Focus Pairs'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {tileFlag && dropDistance && dropDistImages && deviceSettings && dropDistPlots ?
                        <DropDistance {...this.props}/> :
                        <Chip label={'Drop Distance'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                {/*<Grid item margin={0.2}>*/}
                {/*    {fineLocator && deviceSettings && focusPlots && tiltFocusPoints &&*/}
                {/*    focusProfile && countyTiltInfo ? <FineLocatorFocusPoints {...this.props}/> :*/}
                {/*        <Chip label={'All Focus'} size={"small"} color={'primary'}*/}
                {/*              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}*/}
                {/*</Grid>*/}
                <Grid item margin={0.2}>
                    {focusOffset && islands && countyTiltInfo && focusDirPath && deviceSettings ?
                        <Islands {...this.props}/> :
                        <Chip label={'Islands'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {islands && deviceSettings && rescanIslands ? <RescanIslands {...this.props}/> :
                        <Chip label={'Rescan Islands'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {islands && deviceSettings && take2Islands ? <Take2Islands {...this.props}/> :
                        <Chip label={'Take 2 Islands'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTY {...this.props}/> :
                        <Chip label={'TXTY'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYText {...this.props}/> :
                        <Chip label={'TXTY Text'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYPattern {...this.props} 
                    maxNorthX={this.maxNorthX} minNorthX={this.minNorthX} maxNorthY={this.maxNorthY} minNorthY={this.minNorthY}
                        maxWestX={this.maxWestX} minWestX={this.minWestX} minWestY={this.minWestY} maxWestY={this.maxWestY}
                        controller="NTX" /> :
                        <Chip label={'NTX'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYPattern {...this.props} 
                    maxNorthX={this.maxNorthX} minNorthX={this.minNorthX} maxNorthY={this.maxNorthY} minNorthY={this.minNorthY}
                        maxWestX={this.maxWestX} minWestX={this.minWestX} minWestY={this.minWestY} maxWestY={this.maxWestY}
                        controller="NTY" /> :
                        <Chip label={'NTY'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYPattern {...this.props} 
                    maxNorthX={this.maxNorthX} minNorthX={this.minNorthX} maxNorthY={this.maxNorthY} minNorthY={this.minNorthY}
                        maxWestX={this.maxWestX} minWestX={this.minWestX} minWestY={this.minWestY} maxWestY={this.maxWestY}
                        controller="WTX" /> :
                        <Chip label={'WTX'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYPattern {...this.props} 
                    maxNorthX={this.maxNorthX} minNorthX={this.minNorthX} maxNorthY={this.maxNorthY} minNorthY={this.minNorthY}
                        maxWestX={this.maxWestX} minWestX={this.minWestX} minWestY={this.minWestY} maxWestY={this.maxWestY}
                        controller="WTY" /> :
                        <Chip label={'WTY'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {scanMeta ? <TXTYPatternText {...this.props}/> :
                        <Chip label={'TXTY Pattern Text'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {ratioBlurCorner && rescanThresh && rescanThresh2 ? <CornerBlur {...this.props}/> :
                        <Chip label={'Corner Blur'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {ratioBlurCorner && rescanThresh && rescanThresh2 ? <CornerBlurText {...this.props}/> :
                        <Chip label={'Corner Blur Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {wsi3ZDropOutput && deviceSettings ? <Wsi3ZDropThresh {...this.props}/> :
                        <Chip label={'Z-Drop Thresh'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {zDropUnits && deviceSettings ? <ZDropUnits {...this.props}/> :
                        <Chip label={'Z-Drop Units'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {normBlurValsFourd && <FFTRatioFourD {...this.props}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {normBlurValsFourd && rescanThresh && rescanThresh2 ? <FFTRatioFourDH {...this.props}/> :
                        <Chip label={'FFT Ratio FourDH'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {focusOffset && islands && countyTiltInfo && focusDirPath && deviceSettings && normBlurValsFourd && rescanThresh && rescanThresh2 ?
                        <FFTRatioFourDText {...this.props}/> :
                        <Chip label={'FFT Ratio FourD Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {focusOffset && islands && countyTiltInfo && focusDirPath && deviceSettings &&
                     normBlurValsFourd ? <FFTFourDText {...this.props}/> :
                        <Chip label={'FFT FourD Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>Take 1</Grid>
                <Grid item margin={0.2}>
                    {normBlurValsFourdTake1 && <FFTRatioFourDT1 {...this.props} />}
                </Grid>
                <Grid item margin={0.2}>
                    {normBlurValsFourdTake1 && rescanThresh && rescanThresh2 ? <FFTRatioFourDHT1 {...this.props}/> :
                        <Chip label={'FFT Ratio FourDH T1'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {focusOffset && islands && countyTiltInfo && focusDirPath && deviceSettings && normBlurValsFourdTake1 && rescanThresh && rescanThresh2 ?
                        <FFTRatioFourDText {...this.props} normBlurValsFourd={normBlurValsFourdTake1} label={'FFT Ratio FourD T1 Text'}/> :
                        <Chip label={'FFT Ratio FourD T1 Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {normBlurValsFourdTake1 ? 
                        <FFTFourDT1Text {...this.props}/> :
                        <Chip label={'FFT FourD T1 Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>R0</Grid>
                <Grid item margin={0.2}>
                    {stitchPathR0 && stitchStartPosR0 ? <StitchRound0Graphv2 {...this.props}/> :
                        <Chip label={'Path'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPreR0Disagreement ? <StitchPreRound0Disagreementv2 {...this.props}/> :
                        <Chip label={'Before'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPostR0Disagreement ? <StitchPostRound0Disagreementv2 {...this.props}/> :
                        <Chip label={'After'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchR0TileMotion ? <StitchRound0TileMotionv2 {...this.props}/> :
                        <Chip label={'Tiles Moved'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>R1</Grid>
                <Grid item margin={0.2}>
                    {stitchPathR1 && stitchStartPosR1 ? <StitchRound1Graphv2 {...this.props}/> :
                        <Chip label={'Path'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPreR1Disagreement ? <StitchPreRound1Disagreementv2 {...this.props}/> :
                        <Chip label={'Before'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPostR1Disagreement ? <StitchPostRound1Disagreementv2 {...this.props}/> :
                        <Chip label={'After'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchR1TileMotion ? <StitchRound1TileMotionv2 {...this.props}/> :
                        <Chip label={'Tiles Moved'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>R2</Grid>
                <Grid item margin={0.2}>
                    {stitchPathR2 && stitchStartPosR2 ? <StitchRound2Graphv2 {...this.props}/> :
                        <Chip label={'Path'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPreR2Disagreement ? <StitchPreRound2Disagreementv2 {...this.props}/> :
                        <Chip label={'Before'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPostR2Disagreement ? <StitchPostRound2Disagreementv2 {...this.props}/> :
                        <Chip label={'After'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchR2TileMotion ? <StitchRound2TileMotionv2 {...this.props}/> :
                        <Chip label={'Tiles Moved'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>R3</Grid>
                <Grid item margin={0.2}>
                    {stitchPathR3 && stitchStartPosR3 ? <StitchRound3Graphv2 {...this.props}/> :
                        <Chip label={'Path'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPreR3Disagreement ? <StitchPreRound3Disagreementv2 {...this.props}/> :
                        <Chip label={'Before'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchPostR3Disagreement ? <StitchPostRound3Disagreementv2 {...this.props}/> :
                        <Chip label={'After'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchR3TileMotion ? <StitchRound3TileMotionv2 {...this.props}/> :
                        <Chip label={'Tiles Moved'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid item margin={0.2}>
                    {stitchDisagreement ? <StitchDisagreementv2 {...this.props}/> :
                        <Chip label={'Final Disagreement'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchStartPosR0 && stitchDoubtMap ? <StitchGraphTextv2 {...this.props}/> :
                        <Chip label={'Text-Labels'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {stitchDisagreement ? <StitchDisagreementTextv2 {...this.props}/> :
                        <Chip label={'Text'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
            </Grid>

            <Divider/>
            <Grid width={"100%"} container>
                <Grid>FDA:</Grid>
                <Grid item margin={0.2}>
                    {pathUnitMap && focusTestMap && deviceSettings && tileFlag ? <FocusTest {...this.props} metric="f_error"/> : //CHECK BEFORE DEPLOYMENT
                        <Chip label={'FocusTestF-Error'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {pathUnitMap && focusTestMap && deviceSettings && tileFlag ? <FocusTest {...this.props} metric="z_diff"/> : //CHECK BEFORE DEPLOYMENT
                        <Chip label={'FocusTestZ_diff'} size={"small"} color={'primary'} sx={{width: "100%", borderRadius: 0}}
                              disabled={true}/>}
                </Grid>
            </Grid>
            <Divider/>
            <FdaDetails {...this.props} />
            <Divider/>

            <Grid width={"100%"} container>
                <Grid item margin={0.2}>
                    {stitchingError ? <StitchingError {...this.props}/> :
                        <Chip label={'Stitching Error'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            <Grid width={"100%"} container>
                <Grid>Seam Diagnostic:</Grid>
                <Grid item margin={0.2}>
                    {seamDistortion ? <SeamDistortion {...this.props}/> :
                        <Chip label={'Seam Dist'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {seamDistortion ? <SeamDistortionText {...this.props}/> :
                        <Chip label={'Seam Dist Text'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
                <Grid item margin={0.2}>
                    {seamDistortion ? <SeamDistortionVector {...this.props}/> :
                        <Chip label={'Seam Dist Vec'} size={"small"} color={'primary'}
                              sx={{width: "100%", borderRadius: 0}} disabled={true}/>}
                </Grid>
            </Grid>
            {seamDiagnosticSummary && <SeamDiagnosticSummary {...this.props}/>}
            <Typography>
                Rescan Workflow : {rescanWorkflow ? this.getRescanWorkFlow() : null}
            </Typography>
            <Typography>
                RThresh1 : {this.getRescanThreshValComponent1()}
                RThresh2 : {this.getRescanThreshValComponent2()}
            </Typography>
        </Grid>;
    }
}

const mapStateToProps = (state) => {
    let {activeMapId} = state.gammaStateReducer;
    let {
        rescanWorkflow,
        tileFlag,
        multipleWSI3Focus,
        WSI3TestFocusUnits,
        focusOffset,
        failedFocus,
        multipleFocusData,
        focusPlots,
        pathUnitMap,
        focusTestMap,
        deviceSettings,
        ratioBlurCorner,
        sporadicCells,
        rescanThresh,
        rescanThresh2,
        countyTiltInfo,
        scanFocusDebug,
        tiltFocusPoints,
        tiltFocusPairs,
        focusProfile,
        dicy,
        focusDicy,
        focusPairs,
        focusImgPath,
        focusDirPath,
        normBlurValsFourd,
        normBlurValsFourdTake1,
        islands,
        rescanIslands,
        take2Islands,
        streaks,
        scanMeta,
        stitchDisagreement,
        stitchingError,
        seamDistortion,
        seamDiagnosticSummary,
        stitchDoubtMap,
        stitchPostR0Disagreement,
        stitchPreR0Disagreement,
        stitchR0TileMotion,
        stitchPostR1Disagreement,
        stitchPreR1Disagreement,
        stitchR1TileMotion,
        stitchPostR2Disagreement,
        stitchPreR2Disagreement,
        stitchR2TileMotion,
        stitchPostR3Disagreement,
        stitchPreR3Disagreement,
        stitchR3TileMotion,
        stitchPathR0,
        stitchPathR1,
        stitchPathR2,
        stitchPathR3,
        stitchStartPosR0,
        stitchStartPosR1,
        stitchStartPosR2,
        stitchStartPosR3,
        dropDistance,
        dropDistImages,
        fineLocator,
        dropDistPlots,
        wsi3ZDropOutput,
        zDropUnits,
        z
    } = state.mapsStateReducer[activeMapId];

    return {
        activeMapId,
        focusPlots,
        pathUnitMap,
        focusTestMap,
        deviceSettings,
        ratioBlurCorner,
        sporadicCells,
        rescanThresh,
        rescanThresh2,
        countyTiltInfo,
        scanFocusDebug,
        tiltFocusPoints,
        tiltFocusPairs,
        focusProfile,
        dicy,
        focusDicy,
        focusPairs,
        focusImgPath,
        focusDirPath,
        normBlurValsFourd,
        normBlurValsFourdTake1,
        islands,
        rescanIslands,
        take2Islands,
        streaks,
        scanMeta,
        stitchDisagreement,
        stitchingError,
        seamDistortion,
        seamDiagnosticSummary,
        stitchDoubtMap,
        stitchPostR0Disagreement,
        stitchPreR0Disagreement,
        stitchR0TileMotion,
        stitchPostR1Disagreement,
        stitchPreR1Disagreement,
        stitchR1TileMotion,
        stitchPostR2Disagreement,
        stitchPreR2Disagreement,
        stitchR2TileMotion,
        stitchPostR3Disagreement,
        stitchPreR3Disagreement,
        stitchR3TileMotion,
        stitchPathR0,
        stitchPathR1,
        stitchPathR2,
        stitchPathR3,
        stitchStartPosR0,
        stitchStartPosR1,
        stitchStartPosR2,
        stitchStartPosR3,
        dropDistance,
        dropDistImages,
        fineLocator,
        dropDistPlots,
        wsi3ZDropOutput,
        zDropUnits,
        multipleFocusData,
        failedFocus,
        focusOffset,
        WSI3TestFocusUnits,
        multipleWSI3Focus,
        tileFlag,
        rescanWorkflow,
        z
    };
}
export default connect(mapStateToProps)(TileLayers);